import { Box } from '@mui/material';
import React from 'react';
export interface BlockitemProps {
  header: React.ReactElement;
  content: React.ReactElement;
}
const BlockItem = (props: BlockitemProps) => {
  const { content, header } = props;
  return (
    <>
      <Box mb="4px" fontSize="14px" fontWeight="600">
        {header}
      </Box>
      <Box mb="24px" fontSize="14px">
        {content}
      </Box>
    </>
  );
};
export default BlockItem;
